import { TypographyFontWeight } from '@/constants/typographyTypes';
import { CookieManagementLink as CookieManagementLinkType } from '@/schemas/sceneDataSchema';
import { Link } from '@mui/material';
import useAnalytics from '@/hooks/use-analytics';

declare global {
  interface Window {
    Osano?: {
      cm: {
        drawerOpen: boolean;
        hideDrawer: (target: string) => void;
        showDrawer: (target: string) => void;
      };
    };
  }
}

export const CookieManagementLink = ({ component }: { component: CookieManagementLinkType }) => {
  const { trackEvent } = useAnalytics();

  const onClick = () => {
    if (window.Osano === undefined) {
      trackEvent('COOKIE_MANAGEMENT_CLICKED_WITHOUT_OSANO_LOADED');
      return;
    }

    if (window.Osano.cm.drawerOpen) {
      trackEvent('OSANO_DRAWER_CLOSED');
      window.Osano.cm.hideDrawer('osano-cm-dom-info-dialog-open');
    } else {
      trackEvent('OSANO_DRAWER_OPENED');
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  };

  return (
    <Link
      onClick={onClick}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? TypographyFontWeight.REGULAR}
      target='_blank'
      rel='noopener noreferrer'
    >
      {component.text}
    </Link>
  );
};
